import React, { useState } from "react";
import classes from "./MainPage.module.css";
import { ReactComponent as RightArrow } from "../../assets/Vector 14.svg";
import { ReactComponent as Leftrrow } from "../../assets/Vector 15.svg";
import { ReactComponent as SearchIcon } from "../../assets/searchTrackOrder.svg";
import { ReactComponent as FirstTruck } from "../../assets/firstTruckSvg.svg";
import { ReactComponent as SecondTruck } from "../../assets/secondTruckSvg.svg";
import { ReactComponent as GlobeIcon } from "../../assets/globeIcon.svg";

import sherbimetPhoto from "../../assets/sherbimetPhoto.png";
import firstImage from "../../assets/firstImage.png";
import secondImage from "../../assets/secondImage.png";
import thirdImage from "../../assets/thirdImage.png";
import fourthImage from "../../assets/fourthImage.png";
import fifthImage from "../../assets/fifthImage.png";
import { Button, Image, Input } from "antd";
import DefaultInput from "../../components/form/DefaultInput";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link, useNavigate } from "react-router-dom";
import NewsDiv from "./ForUs/NewsDiv";
import api from "../../utils/axios";
import { toast } from "react-toastify";
import ChatBotImg from "../../assets/chatbot.png";

interface OrderData {
	id: string;
	statusDescription: string;
}

const MainPage = () => {
	const navigate = useNavigate();
	const [orderId, setOrderId] = useState("");
	const [orderData, setOrderData] = useState<OrderData[]>([]);
	const [name, setName] = useState("");
	const [email, setEmail] = useState("");
	const [phone, setPhone] = useState("");
	const [message, setMessage] = useState("");

	var settings = {
		dots: true,
		infinite: false,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		initialSlide: 0,
		nextArrow: <RightArrow />,
		prevArrow: <Leftrrow />,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: true,
					dots: true,
				},
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: true,
					dots: true,
				},
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					initialSlide: 1,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	};

	const secondSlider = {
		dots: false,
		infinite: true,
		speed: 500,
		slidesToShow: 4,
		slidesToScroll: 1,
		nextArrow: <RightArrow />,
		prevArrow: <Leftrrow />,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
					infinite: true,
					dots: true,
				},
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
					initialSlide: 2,
				},
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
					initialSlide: 2,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	};

	const orderGeneralSearchInfo = async () => {
		try {
			const response = await api.get("Order/select-order-info-search", {
				params: {
					id: orderId,
				},
			});
			if (response.data && response.data.length > 0) {
				setOrderData(response.data);
				navigate(`/order-tracking?id=${encodeURIComponent(orderId)}`);
			} else {
				toast.error("Kjo porosi nuk ekziston");
			}
		} catch (error) {
			console.error(error);
			throw error;
		}
	};

	const conatactUsCleanState = () => {
		setMessage("");
		setName("");
		setPhone("");
		setEmail("");
	};

	const sendEmail = async () => {
		if (!name || !email || !phone || !message) {
			toast.error("Ju lutemi plotësoni të gjitha fushat e kërkuara.");
			return;
		}

		const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		if (!emailPattern.test(email)) {
			toast.error("Ju lutemi vendosni një email të vlefshëm.");
			return;
		}

		const phonePattern = /^\d+$/;
		if (!phonePattern.test(phone)) {
			toast.error(
				"Ju lutemi vendosni një numër telefoni të vlefshëm pa karaktere jo-numerike."
			);
			return;
		}

		const emailData = {
			to: "info@postman-ks.com",
			subject: "Pyetje në Lidhje me Shërbimet Tuaja",
			body: `${message}\n\n${name}\n${phone}\n${email}`,
		};

		try {
			const response = await api.post("message/send-email", emailData, {
				headers: { "Content-Type": "application/json" },
			});
			conatactUsCleanState();
			toast.success("Email u dërgua me sukses!");
		} catch (error) {
			toast.error("Failed to send email");
			console.error(error);
		}
	};

	return (
		<>
			<div className={classes.bossContainer}>
				<div className={classes.mainComponent}>
					<div className={classes.textContainer}>
						<h1 className={classes.h1Text}>
							Dërgesa juaj, misioni ynë!
						</h1>
						<p className={classes.pText}>
							Postman - lider i shërbimeve postare në Kosovë.
						</p>
					</div>
					<div className={classes.orderTrackerContainer}>
						<p className={classes.orderTrackerTitle}>
							Gjurmo dërgesën tuaj!
						</p>
						<p className={classes.orderTrackerText}>
							Përmes këtij funksioni ju mundësohet gjurmimi në
							kohë reale i dërgesës tuaj.
						</p>
						<div className={classes.searchInputContainer}>
							<Input
								className={classes.searchCodeInput}
								placeholder="# Kodi i dërgesës tuaj"
								value={orderId}
								onChange={(e) => setOrderId(e.target.value)}
							/>
							<div
								className={classes.searchCode}
								onClick={orderGeneralSearchInfo}
							>
								<p className="flex items-center gap-1">
									<SearchIcon /> Kërko
								</p>
							</div>
						</div>
						{orderData.length > 0 && (
							<div>
								<p className="text-xl ">
									Porosia{" "}
									<span className="font-bold ">
										#{orderData[0].id}
									</span>{" "}
									është {orderData[0].statusDescription}
								</p>
							</div>
						)}
					</div>
				</div>
				<div className={classes.secondComponent}>
					<div className={classes.orderAIChatbotContainer}>
						<div className={classes.orderTrackerDesc}>
							<p className={classes.orderTrackerTitle}>
								Automatizimi i Biznesit Tuaj
							</p>
							<p className={classes.orderTrackerText}>
								Platforma Postman në bashkëpunim me Terra kanë
								krijuar chatbot-in “POSTCHAT” për të ofruar një
								zgjidhje inovative në automatizimin e proceseve
								të biznesit tuaj, nga komunikimi me klientët e
								deri tek dërgimi i porosive.
							</p>
							<a
								href="http://my.terra.marketing/"
								className={classes.terraButton}
							>
								Postchat
							</a>
						</div>
						<Image
							src={ChatBotImg}
							preview={false}
							height={500}
							// width={400}
						/>
					</div>
					<div className={classes.secondFirstItem}>
						<p className={classes.secondFirstItemText}>
							Shërbimet tona
						</p>
						<p className={classes.secondFirstItemDesc}>
							POSTMAN është lider në ofrimin e shërbimeve postare
							të shpejta dhe të sigurta. Me përkushtim ndaj
							cilësisë dhe efikasitetit, ne ofrojmë zgjidhje
							postare të besueshme për klientët tanë, si në nivel
							lokal ashtu edhe ndërkombëtar. Me ekipin tonë
							profesional ne ju sigurojmë që çdo dërgesë të arrijë
							në kohë dhe në gjendje të përkryer.
						</p>
						<Image src={sherbimetPhoto} preview={false} />
					</div>
				</div>
				<div className={classes.thirdComponent}>
					<div className={classes.thirdComponentText}>
						<p className={classes.thirdComponentTitle}>
							Pse të zgjedhni POSTMAN?
						</p>
						<p className={classes.thirdComponentDesc}>
							Zgjedhni shërbimet tona për dërgesa të shpejta dhe
							të sigurta.
						</p>
					</div>
					<div className={classes.thirdContainerImages}>
						<div className={classes.firstImagesContainer}>
							<div>
								<Image src={firstImage} preview={false} />
							</div>
							<div>
								<Image src={secondImage} preview={false} />
							</div>
						</div>
						<div className={classes.firstImagesContainer}>
							<Image src={thirdImage} preview={false} />
							<Image src={fourthImage} preview={false} />
							<Image src={fifthImage} preview={false} />
						</div>
					</div>
				</div>
				<div className={classes.fourthComponent}>
					<FirstTruck className={classes.firstTruck} />
					<div className={classes.fourthComponentInfos}>
						<div className={classes.fourthComponentTilteContainer}>
							<p className={classes.fourthComponentTitle}>
								Ne trokitëm në derë <br /> dhe ju na i hapët
								zemrat.
							</p>
							<Link to="/for-us" className={classes.forUsButton}>
								Për ne <span className="text-xl">&#8250;</span>
							</Link>
						</div>
						<div className={classes.fourthComponentInfosContainer}>
							<div className={classes.infosContainerDiv}>
								<p className={classes.infosContainerDivTitle}>
									Rritje e vazhdueshme
								</p>
								<p>
									Që prej themelimit të kompanisë, vazhdimisht
									kemi shënuar rritje në treg.
								</p>
							</div>
							<div className={classes.infosContainerDiv}>
								<p className={classes.infosContainerDivTitle}>
									Përkushtim
								</p>
								<p>
									Ne jemi të përkushtuar në ofrimin e
									shërbimeve profesionale për klientët tanë.
								</p>
							</div>
							<div className={classes.infosContainerDiv}>
								<p className={classes.infosContainerDivTitle}>
									Në çdo vend
								</p>
								<p>
									Postman bënë transportin e dërgesave në çdo
									vend brenda Kosovës, në Shqipëri dhe
									Maqedoni të Veriut.
								</p>
							</div>
						</div>
					</div>
					<SecondTruck className={classes.secondTruck} />
				</div>
				<div className={classes.fifthComponent}>
					<div className={classes.fifthMainComponent}>
						<div className={classes.fifthComponentFirstDiv}>
							<div className={classes.fifthComponentInfoDesc}>
								<p className={classes.fifthComponentTitle}>
									PSE NA ZGJEDHIN NEVE?
								</p>
								<p className={classes.fifthComponentTitleDesc}>
									Pikat tona kryesore
								</p>
							</div>
						</div>
						<div className={classes.fifthComponentSecondThird}>
							<div className={classes.fifthComponentSecondDiv}>
								<div className={classes.fifthComponentInfoDiv}>
									<p className={classes.fifthComponentNumber}>
										1
									</p>
									<div className={classes.line} />
									<div
										className={
											classes.fifthComponentInfoDescription
										}
									>
										<p
											className={
												classes.infoDescriptionTitle
											}
										>
											Kapacitet
										</p>
										<p>
											<b>Mbi 400 mjete transporti</b> janë
											në shërbimin tuaj për të dërguar me
											mijëra porosi në lokacionin e duhur.
										</p>
									</div>
								</div>
								<div className={classes.fifthComponentInfoDiv}>
									<p className={classes.fifthComponentNumber}>
										2
									</p>
									<div className={classes.line} />
									<div
										className={
											classes.fifthComponentInfoDescription
										}
									>
										<p
											className={
												classes.infoDescriptionTitle
											}
										>
											Qasja e lehtë
										</p>
										<p>
											Mjafton që ju ta shkarkoni
											aplikacionin tonë, ku dërgesat mund
											t’i përcillni në kohë reale.
										</p>
									</div>
								</div>
								<div className={classes.fifthComponentInfoDiv}>
									<p className={classes.fifthComponentNumber}>
										3
									</p>
									<div className={classes.line} />
									<div
										className={
											classes.fifthComponentInfoDescription
										}
									>
										<p
											className={
												classes.infoDescriptionTitle
											}
										>
											Misioni
										</p>
										<p>
											Jemi të vendosur që të ofrojmë vlerë
											të shtuar në treg, dhe të ndikojmë
											në transformimin dhe lehtësimin e të
											bërit biznes.
										</p>
									</div>
								</div>
								<div className={classes.fifthComponentInfoDiv}>
									<p className={classes.fifthComponentNumber}>
										4
									</p>
									<div className={classes.line} />
									<div
										className={
											classes.fifthComponentInfoDescription
										}
									>
										<p
											className={
												classes.infoDescriptionTitle
											}
										>
											Vizioni
										</p>
										<p>
											Synojmë që duke përdorur
											kreativitetin dhe ambiciet e ekipit
											tonë, të jemi pjesë e tregjeve
											ndërkombëtare.
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className={classes.fifthSecondComponent}>
						<div className={classes.fifthFirstContainer}>
							<p className={classes.contactTitle}>
								Na kontaktoni
							</p>
							<div className={classes.inputsContainer}>
								<DefaultInput
									className={classes.nameInput}
									placeholder="Emri dhe Mbiemri"
									value={name}
									onChange={(e) => setName(e.target.value)}
								/>
								<div className={classes.emailPhoneContainer}>
									<DefaultInput
										className={classes.emailPhoneInput}
										placeholder="Email"
										value={email}
										onChange={(e) =>
											setEmail(e.target.value)
										}
									/>
									<DefaultInput
										className={classes.emailPhoneInput}
										placeholder="Numri i telefonit"
										value={phone}
										onChange={(e) =>
											setPhone(e.target.value)
										}
										type="number"
									/>
								</div>
								<DefaultInput
									className={classes.messageInput}
									placeholder="Mesazhi..."
									value={message}
									onChange={(e) => setMessage(e.target.value)}
								/>
								<Button
									className={classes.buttonSend}
									onClick={sendEmail}
								>
									Dërgo
								</Button>
							</div>
						</div>
						<div className={classes.fifthSecondContainer}>
							<GlobeIcon />
						</div>
					</div>
					<div className={classes.infoMainContainer}>
						<div className={classes.infoContainer}>
							<div className={classes.bussinesContainer}>
								<p className={classes.bussinesNumber}>5,000+</p>
								<p className={classes.bussinesDescription}>
									Biznese të kënaqura
								</p>
							</div>
							<div className={classes.bussinesContainer}>
								<p className={classes.bussinesNumber}>
									15,000+
								</p>
								<p className={classes.bussinesDescription}>
									Porosi në ditë
								</p>
							</div>
							<div className={classes.bussinesContainer}>
								<p className={classes.bussinesNumber}>400+</p>
								<p className={classes.bussinesDescription}>
									Mjete transporti
								</p>
							</div>
						</div>
					</div>
				</div>
				<NewsDiv />
			</div>
		</>
	);
};

export default MainPage;
